import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap'

import InputGroup from '../../../common/InputGroup'
import { notificationSuccess } from '../../../utils/customToastify'

const Unsubscribe = ({ match, history, addHistoryClick }) => {
  const [email, setEmail] = useState('')
  const [isUnsubscribed, setIsUnsubscribed] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    const parsedSearch = queryString.parse(history.location.search)
    setEmail(parsedSearch.email)
  }

  const onUnsubcribeClick = async () => {
    const decodedSearch = queryString.parse(history.location.search)
    const { token } = match.params
    await addHistoryClick(token, decodedSearch.redirectLink)
    setIsUnsubscribed(true)
    notificationSuccess('You are now unsubscribed!')
  }

  const onGoBackClick = () => {
    window.close()
    return false
  }

  return (
    <>
      <Row>
        <Col>
          <Button className='btn btn-sm gold-color-button mt-2 ml-2' onClick={onGoBackClick}>
            <i class='fas fa-arrow-left mr-2'></i> Go back to email
          </Button>
        </Col>
      </Row>
      <div className='centered'>
        <Row>
          <Col md='4'></Col>
          <Col md='4'>
            <Card>
              <CardHeader>Verified Unsubscribe</CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    Submit your email address below to verify that you'd like to be placed on this sender's{' '}
                    <strong>"Do Not Contact"</strong> list. By doing so, Compass Holding ensures that you will no longer
                    receive emails from them
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup
                      label='Email Address'
                      placeholder='Email Address'
                      name='email'
                      onChange={() => {}}
                      value={email}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-1'>
                  <Col>
                    <small className='text-muted'>
                      This email will be unsubscribed from all existing and future lists owned by Compass Holding
                    </small>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className='btn btn-sm gold-color-button btn-block'
                      onClick={onUnsubcribeClick}
                      disabled={isUnsubscribed}
                    >
                      Unsubscribe
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md='4'></Col>
        </Row>
      </div>
    </>
  )
}

export default Unsubscribe
